import ActionTypeCliente from "../ActionTypeCliente";

export default class CargaDeClientesBuscados extends ActionTypeCliente {
    ejecutar(estado, nuevoEstado) {
        nuevoEstado.flag.procesandoComando = false;
        nuevoEstado.data = this.payload;
        return nuevoEstado;
    }
}
